import { render, staticRenderFns } from "./CreatePayment.vue?vue&type=template&id=efcd2d30&"
import script from "./CreatePayment.vue?vue&type=script&lang=js&"
export * from "./CreatePayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports